import { ReturnSchedule, ReturnsInterval } from '~app/graph/generated/graphql'

/**
 * Maps a ReturnsInterval enum (from the API) to the corresponding ReturnSchedule
 * enum (used in mutations). The ReturnSchedule includes an additional "Off" value
 * that has no ReturnsInterval counterpart, so null/undefined maps to Off.
 */
export const getReturnsScheduleFromReturnsInterval = (
  interval: ReturnsInterval | undefined | null
): ReturnSchedule =>
  interval
    ? {
        [ReturnsInterval.BiWeekly]: ReturnSchedule.BiWeekly,
        [ReturnsInterval.Daily]: ReturnSchedule.Daily,
        [ReturnsInterval.HalfYearly]: ReturnSchedule.HalfYearly,
        [ReturnsInterval.Monthly]: ReturnSchedule.Monthly,
        [ReturnsInterval.Quarterly]: ReturnSchedule.Quarterly,
        [ReturnsInterval.Weekly]: ReturnSchedule.Weekly,
        [ReturnsInterval.Yearly]: ReturnSchedule.Yearly,
      }[interval]
    : ReturnSchedule.Off

/**
 * The schedules a customer can be put on. The API and the returns scheduler
 * also implement half-yearly and yearly, but neither is offered commercially,
 * so they are not choices here.
 */
export const selectableReturnIntervals = [
  ReturnSchedule.Daily,
  ReturnSchedule.Weekly,
  ReturnSchedule.BiWeekly,
  ReturnSchedule.Monthly,
  ReturnSchedule.Quarterly,
  ReturnSchedule.Off,
] as const
